import { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import { Link, useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import { textes } from "../../constants/textes";
import { Spinner } from "react-bootstrap";
import { Building, BuildingFill, CreditCard, People, PeopleFill, PersonCheckFill } from "react-bootstrap-icons";

// import SiteDash from "../sites/sitedash";
// import HotspotDash from "../hotspots/hotsoptdash";
import TransactionDash from "../transactions/transactiondash";

export default function RevendeurDashbord() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    // const [loading2, setLoading2] = useState(true);
    // const [loading3, setLoading3] = useState(true);
    const [error, setError] = useState(false);
    // const [events, setEvents] = useState([]);
    const [page, setPage] = useState(0);

    const [nbtjour, setnbtjour] = useState(0);
    const [nbtmois, setnbtmois] = useState(0);
    const [nbtannee, setnbtannee] = useState(0);
    const [nbttotal, setnbttotal] = useState(0);

    const [monttjour, setmonttjour] = useState(0);
    const [monttmois, setmonttmois] = useState(0);
    const [monttannee, setmonttannee] = useState(0);
    const [montttotal, setmontttotal] = useState(0);
    
    const [nbsite, setnbsite] = useState(0);
    const [nbuser, setnbuser] = useState(0);
    const [nbuserconnect, setnbuserconnect] = useState(0);

    const [transactions, settransactions] = useState([]);
    // const [sites, setsites] = useState([]);
    // const [hotsopts, sethotsopts] = useState([]);

    function getlastnbday(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    // function getcurrentyear(date) {
    //     return new Date(date.getFullYear())
    // }

    const currentdate = new Date().toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');

    console.log("current date:", currentdate);
    console.log("current month:", currentdate.slice(5, 7));
    console.log("current year:", currentdate.slice(0, 4));

    // const getElementsList = async (p) => {
    //     setLoading(true);

    //     var myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    //     myHeaders.append("Authorization", user.token);
    //     myHeaders.append("cpte", user.code);
    //     myHeaders.append("prof", user.profil);
    //     myHeaders.append("conn", user.token);

    //     var requestOptions = {
    //         method: "GET",
    //         headers: myHeaders,
    //         // body: urlencoded,
    //         redirect: "follow",
    //     };

    //     let structarraydata = [];

    //     // console.log("data send", urlencoded)


    // };

    const getCounts = async (p) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&deb=${currentdate}&etat=4`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbtjour(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&deb=${currentdate.slice(0, 7) + "-01"}&fin=${currentdate.slice(0, 7) + "-" + getlastnbday(new Date())}&etat=4`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbtmois(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&deb=${currentdate.slice(0, 4) + "-01-01"}&fin=${currentdate.slice(0, 4) + "-12-" + getlastnbday(new Date())}&etat=4`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbtannee(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=4`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbttotal(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 4 catch");
        });

        // montants
        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=4&defaut=false&deb=${currentdate}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setmonttjour(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=4&defaut=false&deb=${currentdate.slice(0, 7) + "-01"}&fin=${currentdate.slice(0, 7) + "-" + getlastnbday(new Date())}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setmonttmois(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=4&defaut=false&deb=${currentdate.slice(0, 4) + "-01-01"}&fin=${currentdate.slice(0, 4) + "-12-" + getlastnbday(new Date())}}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setmonttannee(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&etat=4&defaut=false`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setmontttotal(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 4 catch");
        });

        // stats sites
        // await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?page=${p + 1}&coderevendeur=${user?.codeutilisateur}&deb=${currentdate}`, requestOptions).then((response) => {
        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?page=${p + 1}&coderevendeur=${user?.codeutilisateur}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbsite(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&crit=allconnectedusers`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbuserconnect(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${100000000}&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&crit=allusers`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        // let clientarray = [];

                        // clientarray = data?.body?.data;

                        // setElementsList(clientarray);
                        // setNbpage(data?.body?.pages);
                        setnbuser(data?.body?.length);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            console.log("get count error 1 server");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("get count error 1 statut");
            }

        }).catch((err) => {
            console.log("get count error 1 catch");
        });
    }

    const getTransactions = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=1000000000&page=${p + 1}&coderevendeur=${user?.codeutilisateur}&deb=${currentdate}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        settransactions(clientarray);
                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        // getElementsList(page);
        getCounts(page);
        getTransactions(page);
    }, []);


    // affichage
    return (
        <div className="col-md-12 mb-3">
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-info shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                Transactions d'aujourd'hui </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtjour} T / {monttjour} XAF</div>
                                        </div>
                                        <div className="col-auto">
                                            <CreditCard className="text-info" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-info shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                Transactions du mois </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtmois} T / {monttmois} XAF</div>
                                        </div>
                                        <div className="col-auto">
                                            <CreditCard className="text-info" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-info shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                Transactions de l'année </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtannee} T / {monttannee} XAF</div>
                                        </div>
                                        <div className="col-auto">
                                            <CreditCard className="text-info" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-info shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                                Transactions total </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbttotal} T / {montttotal} XAF</div>
                                        </div>
                                        <div className="col-auto">
                                            <CreditCard className="text-info" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-dark shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                                                Nombre de site </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbsite} sites</div>
                                        </div>
                                        <div className="col-auto">
                                            <BuildingFill className="text-dark" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-dark shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                                                Utilisateurs connectés au réseau </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbuser} utilisateurs</div>
                                        </div>
                                        <div className="col-auto">
                                            <PeopleFill className="text-dark" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-4">
                            <div className="card border-left-dark shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                                                Utilisateurs connectés à internet </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbuserconnect} utilisateurs</div>
                                        </div>
                                        <div className="col-auto">
                                            <PersonCheckFill className="text-dark" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-3 mb-4">
                            <div className="card border-left-dark shadow h-100 py-2">
                                <div className="card-body">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col mr-2">
                                            <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                                                Montant total des transactions </div>
                                            <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{montttotal} XAF</div>
                                        </div>
                                        <div className="col-auto">
                                            <CreditCard className="text-dark" style={{ fontSize: 48 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <Link className="text-success float-right" to={"/transactions"}>Voir +</Link>
                                    <h6 className="text-dark">Liste des transactions du jour</h6>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>Client</th>
                                                <th>Souscription</th>
                                                <th>Opérateur</th>
                                                <th>Montant</th>
                                                <th>Montant perçu</th>
                                                <th className="text-center">
                                                    {textes.fr.actionlabel}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading && transactions.length === 0 && (
                                                <tr style={{ borderStyle: "none" }}>
                                                    <th colSpan={7} className="text-center">
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="lg"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                    </th>
                                                </tr>
                                            )}
                                            {!loading && transactions.length === 0 && (
                                                <tr style={{ borderStyle: "none" }}>
                                                    <th colSpan={7} className="text-center">
                                                        {textes.fr.notransactionfound}
                                                    </th>
                                                </tr>
                                            )}
                                            {!loading && transactions.length > 0 &&
                                                transactions?.map((item, index) => (
                                                    <TransactionDash
                                                        transaction={item}
                                                        position={(config.app.limit * page) + index}
                                                        key={index}
                                                    />
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={false}
            weekends={true}
            events={events}
            eventClick={handleEventClick}
            eventContent={renderEventContent} // custom view
            locale={"fr-FR"}
            displayEventTime={false}
            // slotDuration="auto"
          /> */}
                </div>
            </div>
        </div>
    );
}
